import React from 'react';

import { ForgeFctWrapper } from '../components/ForgeFctWrapper/ForgeFctWrapper';
import { ForgeUIExtensionsWrapper } from '../components/ForgeUIExtensionsWrapper/ForgeUIExtensionsWrapper';
import { ExtensionPointProps } from '../types';

export const ForgeExtensionPoint = ({
  shouldCallGetContextToken = true,
  bridge,
  currentUser,
  entryPoint,
  extensionData,
  extensionFilter,
  onInitialRender,
  onTearDown,
  workspace,
  WrapperComponent,
}: ExtensionPointProps): JSX.Element => (
  <ForgeUIExtensionsWrapper
    currentUser={currentUser}
    moduleType={extensionData.type}
    extensionFilter={extensionFilter}
    render={extensions => (
      <ForgeFctWrapper
        bridge={bridge}
        shouldCallGetContextToken={shouldCallGetContextToken}
        currentUser={currentUser}
        entryPoint={entryPoint}
        extensions={extensions}
        extensionData={extensionData}
        onInitialRender={onInitialRender}
        onTearDown={onTearDown}
        workspace={workspace}
        WrapperComponent={WrapperComponent}
      />
    )}
    workspace={workspace}
  />
);
